<template>
  <div class="alert alert-info">
    <span><strong>Atenção!</strong> {{ alertText }}</span>
  </div>
</template>
<script>
export default {
  name: 'lamps-alert',
  props: {
    alertText: {
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Lamps/AlertLamps.vue